// extracted by mini-css-extract-plugin
export default {"Modal":"styles_Modal__BjFnr","Bio":"styles_Bio__i2coI"};